import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import {validacionTagResources} from "../endpoints";

class DialogEditarCantidadValidacionTag extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            cantidad_inv: this.props.cantidad_inv,
            cantidad_actual: this.props.cantidad_actual,
            tag: this.props.tag,
            tipo: this.props.tipo,
            cantidad_final:'',
            titulo: this.props.tipo === 'tags' ? 'Inv.' : this.props.tipo === 'cambios_codigos' ? 'Cambios Codigos Real': 'Por Código',
            codigo: this.props.codigo
        }
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }

    modificarCantidad = () =>{
        validacionTagResources.editarCantidadValidacionTag(this.state.tag, this.state.cantidad_final, this.state.tipo, this.state.codigo).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.props.refrescar("Ha ocurrido un error inesperado","error")
            console.log(error)
        });
    }

    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Modificar cantidad validación tag</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            Tag: {this.state.tag}
                        </Grid>
                        {this.state.codigo !== null && <Grid item xs={12}>
                            Código: {this.state.codigo}
                        </Grid>}
                        <Grid item xs={12}>
                            Cantidad {this.state.titulo}: {this.state.cantidad_inv}
                        </Grid>
                        <Grid item xs={12}>
                            Cantidad validada actual: {this.state.cantidad_actual}
                        </Grid>
                        <Grid item xs={12}>
                            Cantidad final: <TextField type='number' value={this.state.cantidad_final} autoFocus={true} name="cantidad_final" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={!this.state.cantidad_final} variant="contained" onClick={this.modificarCantidad} color="primary">
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>

        )
    }
}
export default DialogEditarCantidadValidacionTag;